import React from 'react';
import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';
import { bluePlanetTheme } from 'ui/theme';
import { fontSizeMedium } from 'ui/theme/themeBluePlanet';

interface PlainTooltipProps {
  title: NonNullable<React.ReactNode>;
  placement?: TooltipProps['placement'];
  children: TooltipProps['children'];
  enterDelay?: number;
}

export default function PlainTooltip({ title, placement = 'top', children, enterDelay = 0 }: PlainTooltipProps) {
  return (
    <MuiTooltip
      title={title}
      placement={placement}
      arrow={true}
      enterDelay={enterDelay}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: bluePlanetTheme.bluePlanetPalette.white,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            border: `1px solid ${bluePlanetTheme.bluePlanetPalette.grey.light}`,
            borderRadius: '8px',
            padding: 0,
            maxWidth: 'none',
            color: bluePlanetTheme.bluePlanetPalette.indigo.main,
            fontSize: fontSizeMedium,
          },
        },
        arrow: {
          sx: {
            '&::before': {
              backgroundColor: bluePlanetTheme.bluePlanetPalette.white,
              border: `1px solid ${bluePlanetTheme.bluePlanetPalette.grey.light}`,
            },
          },
        },
      }}
    >
      <span>{children}</span>
    </MuiTooltip>
  );
}
